exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/*\nbody {\n  font-family: 'Montserrat', 'Avenir', 'Helvetica', sans-serif;\n}\n*/\n\n/*\n.container-wrapper {\n  position: absolute;\n  top: 140px;\n  left: 0;\n  height: calc(100vh - 140px);\n  width: 100vw;\n}\n*/\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/App/main.css
// module id = 813
// module chunks = 0